import { computed, getCurrentInstance, ref } from '@vue/composition-api'

export const useLocator = () => {
  const vm = getCurrentInstance()
  const store = vm.proxy.$store
  const selectedClass = ref('')
  const selectedPlan = ref('')
  const currentSubGroupDetailsLoading = computed(() => store.getters.currentSubGroupDetailsLoading)
  const currentSubGroupDetails = computed(() => store.getters.currentSubGroupDetails[0])

  const classOptions = computed(() => currentSubGroupDetails.value.classPlan)

  const deDupedClasses = computed(() => {
    const classes = {}
    if (classOptions.value) {
      classOptions.value.forEach(classPlan => {
        classes[classPlan.classId] = classPlan
      })
    }
    return Object.values(classes)
  })

  const planOptions = computed(() => {
    if (!Array.isArray(classOptions.value)) {
      return []
    }
    return classOptions.value.filter(classPlan => {
      return selectedClass.value && classPlan.classId === selectedClass.value.classId
    })
  })

  return {
    currentSubGroupDetailsLoading,
    currentSubGroupDetails,
    classOptions,
    deDupedClasses,
    planOptions,
    selectedClass,
    selectedPlan
  }
}
